export const USERS = {
  SETUSERROLE: 'SETUSERROLE'
};

export const setUserRole = role => ({
  type: USERS.SETUSERROLE,
  role
});
